import { Content, ContentFixed, ContentScroll } from "../../common/Content";
import { HeaderMenu } from "../../common/HeaderMenu";
import React, { useState } from "react";
import styles from "./Parameters.module.scss";
import { Card } from "react-bootstrap";
import WorkersEditor from "./WorkersEditor";
import SitesStatusesEditor from "./SitesStatusesEditor";

const Parameters = () => {
  const [workersEditor, setWorkersEditor] = useState({show: false});
  const [sitesStatusesEditor, setSitesStatusesEditor] = useState({show: false});

  return <Content>
    <ContentFixed>
      <HeaderMenu title="Parametres"/>
    </ContentFixed>

    <ContentScroll paddingTop withFab>
      <Card className={styles.parametersContainer}>
        <ParameterType
          name="Ouvriers"
          description="Gestion de la liste des ouvriers"
          onClick={() => setWorkersEditor({show: true})}
        />

        <ParameterType
          name="Statuts des chantiers"
          description="Gestion des différents statuts des chantiers"
          onClick={() => setSitesStatusesEditor({show: true})}
        />
      </Card>
    </ContentScroll>

    <WorkersEditor
      show={workersEditor.show}
      hide={() => setWorkersEditor(prev => ({...prev, show: false}))}
      onSubmit={() => Promise.resolve()}
    />

    <SitesStatusesEditor
      show={sitesStatusesEditor.show}
      hide={() => setSitesStatusesEditor(prev => ({...prev, show: false}))}
      onSubmit={() => Promise.resolve()}
    />
  </Content>;
};

const ParameterType = ({name, description = null, onClick}) => {
  return <div className={styles.parameterType} onClick={onClick}>
    <div className={styles.name}>{name}</div>
    {description && <div className={styles.description}>{description}</div>}
  </div>;
};

export default Parameters;